module.exports = "https://cdn01.riselinkedu.com/assets/lottie/img_2.58a03507.png";